import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { convertToOption } from "src/utils/convertToOption";
import { errorResponsesTrns } from "src/translate/responses";
import { IIndustry } from "src/@types/industry";

export const INDUSTRIES_SLICE_NAME = "industries";

export const getIndustriesAsync = createAsyncThunk(
  `${INDUSTRIES_SLICE_NAME}/fetchIndustries`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IIndustry[]>("/categories/");

      //CHANGE - temp use convertToOption
      return convertToOption(data);
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.industries;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);

export const getIndustryAsync = createAsyncThunk(
  `${INDUSTRIES_SLICE_NAME}/fetchIndustry`,
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<IIndustry>(`/categories/${id}/`);

      //CHANGE - temp use convertToOption
      return convertToOption(data);
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.industry;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);
